'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { configPublic } from '@src/config.public';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
interface BODEnabledConditionalContentProps {
  attributes: any;
  className?: string;
  showIfBODEnabled: boolean;
  children: ReactNode;
}
export function BODEnabledConditionalContent(props) {
  const $ = _c(14);
  const {
    attributes,
    className,
    showIfBODEnabled,
    children
  } = props;
  let edit;
  let t0;
  let t1;
  let t2;
  if ($[0] !== attributes || $[1] !== className) {
    ({
      edit
    } = getBuilderPreviewMode());
    t0 = attributes;
    t1 = attributes?.key;
    t2 = cn("size-auto", className, attributes?.className, {
      "border-4 border-green-400 relative": edit
    });
    $[0] = attributes;
    $[1] = className;
    $[2] = edit;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    edit = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const t3 = attributes?.style;
  let t4;
  if ($[6] !== t3) {
    t4 = {
      ...t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children || $[9] !== t0 || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <div {...t0} key={t1} className={t2} style={t4} suppressHydrationWarning={true}>{children}</div>;
    $[8] = children;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const content = t5;
  if (edit) {
    return content;
  }
  if (showIfBODEnabled === configPublic.featureFlags.onesiteEnabled) {
    return content;
  }
  return null;
}